
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.833 8.335v-2.5a4.167 4.167 0 018.334 0v2.5m-3.334 5a.833.833 0 11-1.666 0 .833.833 0 011.666 0zm-6.666-5h11.666c.92 0 1.667.746 1.667 1.666v6.667c0 .92-.746 1.667-1.667 1.667H4.167c-.92 0-1.667-.747-1.667-1.667v-6.667c0-.92.746-1.666 1.667-1.666z","stroke":"currentColor","stroke-width":"1.667","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    